import React from 'react';
import StyledComponent from '~/components/Styled/Styled';

import css from './MatchupSection.scss';

export class MatchupSection extends React.Component {
  render() {
    return <div className={css.matchupSection}>{this.props.children}</div>;
  }
}

export default StyledComponent(MatchupSection, [css]);
